//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Drafting/Drafting.BaseEditSettingsBuilder.js";
import "../Annotations/Annotations.CuttingPlaneSymbolBuilder.js";
import "../Annotations/Annotations.DisplayStyleBuilder.js";
let d=[[[1,"CuttingPlaneSymbolBuilder",0,"Annotations.CuttingPlaneSymbolBuilder",0],[1,"DisplayStyle",0,"Annotations.DisplayStyleBuilder",0]],[[["selectedObject"],"InheritSettingsFromSelectedObject",{},1,0],[[],"InheritSettingsFromCustomerDefault",{},0,0],[[],"InheritSettingsFromPreferences",{},0,0]],[]];
SPLM.Annotations.PmiEditCuttingPlaneSymbolSettingsBuilder = class extends SPLM.Drafting.BaseEditSettingsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiEditCuttingPlaneSymbolSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;